import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/Login';
import Home from '../pages/Home';
import Chat from '../pages/tanya-dokter/chat/Chat';
import Disclaimer from '../pages/tanya-dokter/disclaimer/Disclaimer';
import ConnectingDoctor from '../pages/tanya-dokter/disclaimer/ConnectingDoctor';
import Profile from '../pages/Akun/Profile';
import EprescriptionList from '../pages/Prescription/EprescriptionList';
import EprescriptionDetail from '../pages/Prescription/EprescriptionDetail';
import EprescriptionOrder from '../pages/Prescription/EprescriptionOrder';
import ConcernPolicyForm from '../pages/Concern/ConcernPolicyForm';
import NewSyaratKetentuan from '../pages/Concern/NewSyaratKetentuan';
import ChatHistories from '../pages/ChatHistory/chat/ChatHistories';
import HealthRecord from '../pages/HealthRecord/HealthRecord';
import ListDoctor from '../pages/tanya-dokter/list/ListDoctor';
import ScheduleConsultation from '../pages/tanya-dokter/list/ScheduleConsultation';
import NotFoundPage from '../pages/NotFoundPage';
import AddressPage from '../pages/Prescription/AddressPage';
import CheckOutPage from '../pages/Prescription/CheckOutPage';
import VideoCall from '../pages/VideoCall/VideoCall';
import SimpleVideoCallForm from '../pages/VideoCall/SimpleVideoCallForm';
import VideoCallUI from '../pages/VideoCall/VideoCallUI';


interface RouterProps {
  isLoggedIn: boolean;
  userId: string | null;
  username: string | null;
  conversationID: string;
  conversationType: number;
  handleLogin: (id: string, name: string) => void;
}


const Router: React.FC<RouterProps> = ({
  isLoggedIn,
  userId,
  username,
  conversationID,
  conversationType,
  handleLogin,
}) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          isLoggedIn ? (
            <Navigate to="/home" replace />
          ) : (
            <Login onLogin={handleLogin} />
          )
        }
      />
      <Route path="/home" element={<Home />} />
      <Route
        path="/chat/:teleconsultationId/:token"
        element={
          isLoggedIn ? (
            <Chat />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/disclaimer/:practitionerRoleId"
        element={
          isLoggedIn ? (
            <Disclaimer />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/connect-doctor/:teleconsultationId/:token"
        element={
          isLoggedIn ? (
            <ConnectingDoctor />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription"
        element={
          isLoggedIn ? (
            <EprescriptionList />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/:prescriptionId"
        element={
          isLoggedIn ? (
            <EprescriptionDetail />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/:prescriptionId/order"
        element={
          isLoggedIn ? (
            <EprescriptionOrder />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/checkout/:prescriptionId/:token"
        element={
          isLoggedIn ? (
            <CheckOutPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/address-page/:prescriptionId/:token"
        element={
          isLoggedIn ? (
            <AddressPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/akun"
        element={
          isLoggedIn ? (
            <Profile />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/concerns/:token"
        element={
          isLoggedIn ? (
            <ConcernPolicyForm />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/new-syarat-dan-ketentuan"
        element={
          isLoggedIn ? (
            <NewSyaratKetentuan />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/chat-history"
        element={
          isLoggedIn ? (
            <ChatHistories
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/health-record"
        element={
          isLoggedIn ? (
            <HealthRecord
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/list-doctor"
        element={
          isLoggedIn ? (
            <ListDoctor
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/schedule-consultation/:doctorId"
        element={
          isLoggedIn ? (
            <ScheduleConsultation />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/not-found"
        element={
          isLoggedIn ? (
            <NotFoundPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/video-call"
        element={
          isLoggedIn ? (
            <VideoCall />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/video-call-ui/:teleconsultationId/:token"
        element={
          isLoggedIn ? (
            <VideoCallUI />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/form-video-call"
        element={
          isLoggedIn ? (
            <SimpleVideoCallForm />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />


    </Routes>
  );
};

export default Router;
